export default __webpack_public_path__ + "static/media/buda.dbb23507.woff2";